if (typeof AbortSignal !== "undefined" && !AbortSignal.any) {
	AbortSignal.any = (signals: AbortSignal[]): AbortSignal => {
		const controller = new AbortController();

		for (const signal of signals) {
			if (signal.aborted) {
				controller.abort(signal.reason);
				return controller.signal;
			}

			signal.addEventListener("abort", () => controller.abort(signal.reason), {
				signal: controller.signal,
			});
		}

		return controller.signal;
	};
}
